var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'max-h-screen overflow-hidden' : _vm.isLoading},attrs:{"id":"app"}},[_c('LoadingApp',{directives:[{name:"show",rawName:"v-show",value:(_vm.isLoading),expression:"isLoading"}]}),(!_vm.isLoading)?_c('vue-extend-layouts'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }